import React, { Component } from 'react';
import Footer from './footer';
import Header from './header';
import Section1Top from './data/section_1_top.jpg';
import Form from './form';


class Section1 extends Component {
    state = {  } 
    render() { 
        return (
            <div className='d-flex flex-column min-vh-100 '>
                <Header onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
                <img src={Section1Top} alt="section1 top" className='section-top'/>
                <div className='pb-2 flex-grow-1'>
                    <div className='row w-100 p-0 m-0'>
                            <div className='col-12 col-lg-9 py-2 pe-lg-4' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='custom-font-size-text-2 px-0 px-sm-3 px-md-4 px-xl-5 mt-2' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onEngLanguage()}>
                                        <div className='pe-0 pe-lg-5'>
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის შესახებ</b>
                                                </div>
                                                <div>
                                                    მასტერკლასის მიზანია მონაწილეს გააცნოს საოპერაციო რისკის მართვის თანამედროვე მიდგომები, 
                                                    რომელიც ეფუძნება საერთაშორისო სტანდარტებსა და აღიარებულ საუკეთესო პრაქტიკებს (Basel, ISO, COSO, EBA), 
                                                    მათ შორის პასუხობს რისკის მართვის პროგრამების საკანონმდებლო და რეგულაციურ მოთხოვნებს. 

                                                
                                                </div>
                                                <div>
                                                    მასტერკლასის ფარგლებში, მონაწილე გაიღრმავებს ცოდნას საოპერაციო რისკების მართვის ინსტრუმენტების შესახებ, გაიზიარებს რისკების მართვის პროგრამების განვითარების პრაქტიკული გამოცდილებას, 
                                                    გაეცნობა ბაზარზე მიმდინარე გამოწვევებს და დაეუფლება მათი დაძლევის სტრატეგიებს.                                                 </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ვისთვისაა მასტერკლასი განკუთვნილი</b>
                                                </div>
                                                <div>
                                                    მასტერკლასი განკუთვნილია ფინანსური და არაფინანსური სექტორის წარმომადგენელი საშუალო და მაღალი რგოლის მენეჯერებისა და წამყვანი სპეციალისტებისათვის, 
                                                    რისკის მართვის, შიდა კონტროლის და აუდიტის მიმართულებით. 
                                                    მასტერკლასზე დასწრების წინაპირობაა მინიმუმ 6 თვიანი სამუშაო გამოცდილება რისკის მართვის მიმართულებით. 
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის დასრულების შემდეგ</b>
                                                </div>
                                                <div>
                                                    მონაწილე გაიღრმავებს ცოდნას რისკის მართვის    
                                                     საერთაშორისო საუკეთესო პრაქტიკებით განსაზღვრული პრინციპებისა და მათი ინტერპრეტაციის შესახებ,    
                                                    რაც მას საშუალებას მისცემს დამოუკიდებლად და/ან მენეჯერული რგოლის დახმარებით შეიმუშაოს ორგანიზაციების
                                                    რისკის მართვის პროგრამის განვითარების საშუალო ვადიანი სტრატეგია. 
                                                    მონაწილე განივითარებს პროფესიულ უნარებს და შეძლებს წარმოადგინოს რისკის მართვის პროცესების 
                                                    გაუმჯობესების სტრატეგიული ინიციატივები და დანერგოს თანამედროვე მიდგომები ორგანიზაციულ დონეზე. 
                                                    
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის შინაარსი</b>
                                                </div>
                                                <div>
                                                    დღე 1
                                                    <ul>
                                                        <li>კორპორაციული მართვა და დაცვის 3 ხაზი</li>
                                                        <li>ძლიერი რისკის კულტურის მნიშვნელობა</li>
                                                        <li>ISO31000 რისკების მართვის სტანდარტი: პრინციპები და მიდგომები</li>
                                                        <li>რისკის მართვა, როგორც ბიზნესის გაზრდის შესაძლებლობა</li>
                                                    </ul>
                                                    დღე 2
                                                    <ul>
                                                        <li>რისკების მართვის რაოდენობრივი კრიტერიუმები</li>
                                                        <li>რისკის აპეტიტის მეტრიკები და რისკის პროფილის მართვა</li>
                                                        <li>რისკის მონიტორინგი, ძირითადი რისკის ინდიკატორები</li>
                                                        <li>სიზუსტის რისკი და რისკის რეპორტინგის სტანდარტი</li>
                                                    </ul>
                                                    დღე 3
                                                    <ul>
                                                        <li>ახალი პროდუქტის დანერგვა და ცვლილებების მართვა</li>
                                                        <li>მესამე მხარისა და აუთსორსინგის რისკების შეფასება</li>
                                                        <li>რისკის ახალი ტრენდების მიმოხილვა</li>
                                                        <li>AI რისკების მართვის ინტეგრაცია საოპერაციო რისკების მართვის პროცესში</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის შესახებ</b>
                                                </div>
                                                <div>
                                                    ნინო ოქრუაშვილი ფლობს 20+ წლიან გამოცდილებას რისკების მართვის პროგრამების 
                                                    შემუშავებისა და განვითარების კუთხით. გააჩნია საერთაშორისო სტანდარტებისა და რეგულატორული მოთხოვნების ექსპერტული ცოდნა. 
                                                    
                                                </div>
                                                <div>
                                                    მას აქვს რისკის მართვის ტრენინგებისა და ცნობიერების ამაღლების პროგრამების
                                                    ორგანიზების მრავალწლიანი გამოცდილება კორპორატიულ გარემოში.
                                                </div>
                                                <div>
                                                    გავლილი აქვს საოპერაციო რისკების მართვის საერთაშორისო
                                                    სასერტიფიკატო კურსები, ორგანიზებული წამყვანი რისკის მართვის 
                                                    ინსტიტუტების მიერ.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>კორპორატიული შეთავაზება</b>
                                                </div>
                                                <div>
                                                    კორპორატიული შეთავაზების მისაღებად, მოგვწერეთ ან დაგვიკავშირდით. <br />
                                                    ჩვენი საკონტაქტო მონაცემებია: <br /> 
                                                    <ul style={{listStyleType: 'none', paddingLeft: '0.75rem'}}>
                                                        <li>Email: nokruashvili@riskadvisor.ge</li>
                                                        <li>ტელ: 599-51-97-83</li>
                                                    </ul>
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.props.onGeoLanguage()}>
                                        <div className='pe-0 pe-lg-5'>
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის შესახებ</b>
                                                </div>
                                                <div>
                                                    მასტერკლასის მიზანია მონაწილეს გააცნოს საოპერაციო რისკის მართვის თანამედროვე მიდგომები, 
                                                    რომელიც ეფუძნება საერთაშორისო სტანდარტებსა და აღიარებულ საუკეთესო პრაქტიკებს (Basel, ISO, COSO, EBA), 
                                                    მათ შორის პასუხობს რისკის მართვის პროგრამების საკანონმდებლო და რეგულაციურ მოთხოვნებს. 

                                                
                                                </div>
                                                <div>
                                                    მასტერკლასის ფარგლებში, მონაწილე გაიღრმავებს ცოდნას საოპერაციო რისკების მართვის ინსტრუმენტების შესახებ, გაიზიარებს რისკების მართვის პროგრამების განვითარების პრაქტიკული გამოცდილებას, 
                                                    გაეცნობა ბაზარზე მიმდინარე გამოწვევებს და დაეუფლება მათი დაძლევის სტრატეგიებს.                                                 </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ვისთვისაა მასტერკლასი განკუთვნილი</b>
                                                </div>
                                                <div>
                                                    მასტერკლასი განკუთვნილია ფინანსური და არაფინანსური სექტორის წარმომადგენელი საშუალო და მაღალი რგოლის მენეჯერებისა და წამყვანი სპეციალისტებისათვის, 
                                                    რისკის მართვის, შიდა კონტროლის და აუდიტის მიმართულებით. 
                                                    მასტერკლასზე დასწრების წინაპირობაა მინიმუმ 6 თვიანი სამუშაო გამოცდილება რისკის მართვის მიმართულებით. 
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის დასრულების შემდეგ</b>
                                                </div>
                                                <div>
                                                    მონაწილე გაიღრმავებს ცოდნას რისკის მართვის    
                                                     საერთაშორისო საუკეთესო პრაქტიკებით განსაზღვრული პრინციპებისა და მათი ინტერპრეტაციის შესახებ,    
                                                    რაც მას საშუალებას მისცემს დამოუკიდებლად და/ან მენეჯერული რგოლის დახმარებით შეიმუშაოს ორგანიზაციების
                                                    რისკის მართვის პროგრამის განვითარების საშუალო ვადიანი სტრატეგია. 
                                                    მონაწილე განივითარებს პროფესიულ უნარებს და შეძლებს წარმოადგინოს რისკის მართვის პროცესების 
                                                    გაუმჯობესების სტრატეგიული ინიციატივები და დანერგოს თანამედროვე მიდგომები ორგანიზაციულ დონეზე. 
                                                    
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის შინაარსი</b>
                                                </div>
                                                <div>
                                                    დღე 1
                                                    <ul>
                                                        <li>კორპორაციული მართვა და დაცვის 3 ხაზი</li>
                                                        <li>ძლიერი რისკის კულტურის მნიშვნელობა</li>
                                                        <li>ISO31000 რისკების მართვის სტანდარტი: პრინციპები და მიდგომები</li>
                                                        <li>რისკის მართვა, როგორც ბიზნესის გაზრდის შესაძლებლობა</li>
                                                    </ul>
                                                    დღე 2
                                                    <ul>
                                                        <li>რისკების მართვის რაოდენობრივი კრიტერიუმები</li>
                                                        <li>რისკის აპეტიტის მეტრიკები და რისკის პროფილის მართვა</li>
                                                        <li>რისკის მონიტორინგი, ძირითადი რისკის ინდიკატორები</li>
                                                        <li>სიზუსტის რისკი და რისკის რეპორტინგის სტანდარტი</li>
                                                    </ul>
                                                    დღე 3
                                                    <ul>
                                                        <li>ახალი პროდუქტის დანერგვა და ცვლილებების მართვა</li>
                                                        <li>მესამე მხარისა და აუთსორსინგის რისკების შეფასება</li>
                                                        <li>რისკის ახალი ტრენდების მიმოხილვა</li>
                                                        <li>AI რისკების მართვის ინტეგრაცია საოპერაციო რისკების მართვის პროცესში</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>მასტერკლასის შესახებ</b>
                                                </div>
                                                <div>
                                                    ნინო ოქრუაშვილი ფლობს 20+ წლიან გამოცდილებას რისკების მართვის პროგრამების 
                                                    შემუშავებისა და განვითარების კუთხით. გააჩნია საერთაშორისო სტანდარტებისა და რეგულატორული მოთხოვნების ექსპერტული ცოდნა. 
                                                    
                                                </div>
                                                <div>
                                                    მას აქვს რისკის მართვის ტრენინგებისა და ცნობიერების ამაღლების პროგრამების
                                                    ორგანიზების მრავალწლიანი გამოცდილება კორპორატიულ გარემოში.
                                                </div>
                                                <div>
                                                    გავლილი აქვს საოპერაციო რისკების მართვის საერთაშორისო
                                                    სასერტიფიკატო კურსები, ორგანიზებული წამყვანი რისკის მართვის 
                                                    ინსტიტუტების მიერ.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>კორპორატიული შეთავაზება</b>
                                                </div>
                                                <div>
                                                    კორპორატიული შეთავაზების მისაღებად, მოგვწერეთ ან დაგვიკავშირდით. <br />
                                                    ჩვენი საკონტაქტო მონაცემებია: <br /> 
                                                    <ul style={{listStyleType: 'none', paddingLeft: '0.75rem'}}>
                                                        <li>Email: nokruashvili@riskadvisor.ge</li>
                                                        <li>ტელ: 599-51-97-83</li>
                                                    </ul>
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                    <a href="/Terms%26Conditions.pdf" download>
                                        მასტერკლასში მონაწილეობის წესები და პირობები
                                    </a>
                                </div>   
                            </div>
                            <div className='col-12 col-lg-3 py-2 pe-xl-5' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='custom-font-size-text-2 px-0 px-sm-3 px-md-4 px-lg-0 mt-2'>
                                    <br />
                                    <div className='d-block position-relative mx-5 my-5 mx-lg-2 mx-xl-4 my-xxl-5' >
                                        <a href="#form" >
                                            <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white', width: '100%', textAlign: 'center' }} >
                                                <div className='h5 mb-3 py-1 rounded register_button' style={{backgroundColor: '#003968'}}>
                                                    <div className={this.props.onEngLanguage()}>
                                                        Register
                                                    </div>
                                                    <div className={this.props.onGeoLanguage()}>
                                                        რეგისტრაცია
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <br />
                                    <div className={this.props.onEngLanguage()}>
                                        <div>
                                            <div>
                                                <b>ჩატარების თარიღი</b> <br /> 23-25 სექტემბერი 2026
                                            </div>
                                            <br />
                                            <div>
                                                <b>ხანგძლივობა და ფორმატი</b>
                                            </div>
                                            <div>
                                                3 შეხვედრა (12 საათი)
                                                <br /><b>ლოკაცია</b>
                                                 
                                                <br />Rooms Hotel Tbilisi
                                                <br />მ. კოსტავას ქ. 14, თბილისი
                                            </div>
                                        </div>
                                        <br />
                                        <div>
                                            <div>
                                                <b>მასტერკლასის ღირებულება</b>
                                            </div>
                                            <div>

                                                1 მონაწილე: 2000 ლარი,
                                                <br />ადრეული რეგისტრაციისას
                                                <br />15.08.26-მდე - 
                                                1500 ლარი
                                             (-25%) <br />
                                                
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.props.onGeoLanguage()}>
                                        <div>
                                            <div>
                                                <b>ჩატარების თარიღი</b> <br /> 23-25 სექტემბერი 2026
                                            </div>
                                            <br />
                                            <div>
                                                <b>ხანგძლივობა და ფორმატი</b>
                                            </div>
                                            <div>
                                                3 შეხვედრა (12 საათი)
                                                <br /><b>ლოკაცია</b>
                                                 
                                                <br />Rooms Hotel Tbilisi
                                                <br />მ. კოსტავას ქ. 14, თბილისი
                                            </div>
                                        </div>
                                        <br />
                                        <div>
                                            <div>
                                                <b>მასტერკლასის ღირებულება</b>
                                            </div>
                                            <div>

                                                1 მონაწილე: 2000 ლარი,
                                                <br />ადრეული რეგისტრაციისას
                                                <br />15.08.26-მდე - 
                                                1500 ლარი
                                             (-25%) <br />
                                                
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div id='form' style={{scrollMarginTop: '85px'}}>
                                        <Form 
                                            onlanguage={this.props.onlanguage}
                                            onChangeLanguage={this.props.onChangeLanguage}
                                            onEngLanguage={this.props.onEngLanguage}
                                            onGeoLanguage={this.props.onGeoLanguage}
                                            program={'operational_risk'}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*
                        <div id='form' style={{scrollMarginTop: '70px'}}>
                            <div className='d-flex flex-column min-vh-100 '>
                                <div className='pb-2 px-5 pt-3 flex-grow-1'>
                                    <div className='row w-100 p-0 m-0'>
                                        <div className='col-12 col-md-3 m-0'>
                                            <Form 
                                                onEngLanguage={this.props.onEngLanguage}
                                                onGeoLanguage={this.props.onGeoLanguage}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                        <br />
                        <br />
                        <br />
                  
                   {/* <Link to="/form" className="text-decoration-none h5">Form</Link>*/}
                </div>        
                <Footer
                    onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
            </div>
        );
    }
}
 
export default Section1 ;